<template>
  <div id="printscheme-add-update-dialog" class="custom-modal">
    <div class="modal-body">
      <transition name="el-fade-in" mode="out-in">
        <HolaconLottie v-if="loading == true && form == null" key="create-loading" />
        <el-row v-else key="content-loading">
          <el-row :gutter="10">
            <el-col :span="24">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("onsiteUtilities.cardDesigner.addUpdate.title") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("onsiteUtilities.cardDesigner.addUpdate.titleMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-input v-model="form.title" :maxlength="50" show-word-limit></el-input>
                <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
              </div>
            </el-col>
            <el-col :span="18" class="mt-3">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("onsiteUtilities.cardDesigner.addUpdate.variable") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("onsiteUtilities.cardDesigner.addUpdate.variableMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <!-- <el-input v-model="form.title"></el-input> -->
                <el-select v-model="addedObj" filterable v-if="groups.length > 0">
                  <el-option-group v-for="(group, groupIndex) in groups" :key="groupIndex + '-dynamicGroup'" :label="group">
                    <el-option v-for="item in dynamicParams.filter(x => x.group == group)" :key="item.key" :label="item.title" :value="item.key"></el-option>
                  </el-option-group>
                </el-select>
              </div>
            </el-col>
            <el-col :span="6" class="mt-3 d-flex justify-content-end align-items-end" style="height:70px;">
              <div class="title"></div>
              <el-upload v-if="form.backgroundImageUrl == null" :onProgress="backgroundProgress" :action="axios.defaults.baseURL + 'event/uploadImage?uploadType=printScheme&language=' + $i18n.locale" :headers="{ Authorization: axios.defaults.headers['Authorization'] }" :show-file-list="false" :on-success="backgroundSuccess">
                <el-button type="primary" slot="trigger" icon="fas fa-plus" :loading="backgroundPercent > 0" :disabled="backgroundPercent > 0" size="medium">{{ $t("onsiteUtilities.cardDesigner.addUpdate.addBg") }}</el-button>
              </el-upload>
              <el-button v-else type="danger" icon="el-icon-close" @click="form.backgroundImageUrl = null" size="medium">{{ $t("onsiteUtilities.cardDesigner.addUpdate.editBg") }}</el-button>
            </el-col>
          </el-row>

          <el-row :gutter="10" class="mt-3">
            <el-col :span="24">
              <div id="designer_wrapper">
                <div id="toolbar">
                  <TextToolbar class="mb-2" :data="getActiveElement" v-if="getActiveElement && getActiveElement.type == 'text'" :fonts="fonts" />
                  <div class="image-toolbar mb-2" v-if="getActiveElement && getActiveElement.type == 'image'" style="display:flex; align-items:center;justify-content:center;gap:10px;">
                    <label class="m-0 p-0">Image Radius</label>
                    <el-input-number :max="100" size="mini" v-model="getActiveElement.radius" :min="0"  step="5"></el-input-number>
                  </div>
                </div>
                <div id="_scene">
                  <div id="_canvas" :style="[getCanvasStyle]">
                    <img :src="form.backgroundImageUrl" v-if="form.backgroundImageUrl != null" style="position:absolute;width:100%;height:100%;left:0;top:0;object-fit:contain;" class="background-image-class" alt="Photo Element" />
                    <div class="objectx"></div>
                    <div class="objecty"></div>
                    <template v-for="element in form.canvas.elements">
                      <DesignerImage @PositionUpdated="positionUpdated" @SizeUpdated="sizeUpdated" @StartEditing="startEditing" @StopEditing="stopEditing" @SetActiveElement="setActiveElement" v-if="element.type == 'image'" :data="element" :key="element.id + historyDate" :isActive="getActiveElement.id == element.id" />
                      <DesignerText @TextChanged="textChanged" @PositionUpdated="positionUpdated" @SizeUpdated="sizeUpdated" @StartEditing="startEditing" @StopEditing="stopEditing" @SetActiveElement="setActiveElement" v-if="element.type == 'text'" :data="element" :key="element.id + historyDate" :isActive="getActiveElement.id == element.id" />
                    </template>
                  </div>
                </div>
                <div id="_zoomController" class="mt-2">
                  <el-input-number style="width: 100px; margin-right: 5px;" size="mini" v-model="form.width" :min="50" :max="1000"></el-input-number>
                  <el-input-number size="mini" style="width: 100px;margin-right: 5px;" v-model="form.height" :min="30" :max="1000"></el-input-number>
                  <el-button size="mini" circle icon="fas fa-trash" @click="deleteElement(getActiveElement.id)" v-if="getActiveElement.id"></el-button>
                </div>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10" class="mt-2">
            <el-col :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="settingsDock = !settingsDock">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("onsiteUtilities.cardDesigner.addUpdate.settings") }}</label>
                      <!-- <el-tooltip content="Content" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{ $t("onsiteUtilities.cardDesigner.addUpdate.settingsMsg") }}</span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="settingsDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="settingsDock">
                    <div class="custom-set-container" :class="form.isActive ? 'sactive' : 'spassive'">
                      <div class="custom-set-inner">
                        <i class="fa" :class="form.isActive ? 'fa-eye' : 'fa-eye-slash'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("onsiteUtilities.cardDesigner.addUpdate.view") }}
                            <!-- <el-tooltip content="Content" placement="bottom">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("onsiteUtilities.cardDesigner.addUpdate.viewMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.isActive"></el-switch>
                      </div>
                    </div>

                    <div class="custom-set-container" :class="form.enableBackgroundImagePrint ? 'sactive' : ''">
                      <div class="custom-set-inner">
                        <i class="fa" :class="form.enableBackgroundImagePrint ? 'fa-print' : 'fa-image'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("onsiteUtilities.cardDesigner.addUpdate.printBg") }}
                            <!-- <el-tooltip content="Content" placement="bottom">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("onsiteUtilities.cardDesigner.addUpdate.printBgMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.enableBackgroundImagePrint"></el-switch>
                      </div>
                    </div>

                    <div class="custom-set-container" :class="form.enableTextTransform ? 'sactive' : 'swarning'">
                      <div class="custom-set-inner">
                        <i :class="form.enableTextTransform ? 'fa fa-bold' : 'fas fa-strikethrough'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("onsiteUtilities.cardDesigner.addUpdate.textCustomization") }}
                            <el-tooltip placement="top">
                              <div slot="content" class="custom-tooltip-content">
                                <span>{{ $t("onsiteUtilities.cardDesigner.addUpdate.textCustomizationMsg") }}</span>
                              </div>
                              <i class="el-icon-info"></i>
                            </el-tooltip>
                          </label>
                          <span>{{ $t("onsiteUtilities.cardDesigner.addUpdate.textCustomizationMsg2") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.enableTextTransform"></el-switch>
                      </div>
                      <div class="custom-set-actions fcenter mt-3" v-show="form.enableTextTransform">
                        <el-select v-model="form.printMode">
                          <el-option v-for="item in $enums.printMode" :key="item.value" :label="item.title" :value="item.value"></el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>
        </el-row>
      </transition>
    </div>
    <div class="modal-footer" slot="footer" v-if="loading != true && form != null">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("onsiteUtilities.cardDesigner.addUpdate.close") }}</el-button>
        <template v-if="form.id != null">
          <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
            <el-button slot="reference" type="danger" icon="fas fa-trash">{{ $t("onsiteUtilities.cardDesigner.addUpdate.delete") }}</el-button>
          </el-popconfirm>
        </template>
      </div>
      <div class="right-buttons">
        <el-button type="primary" @click="save" :loading="loading == 'saveCard'">{{ $t("onsiteUtilities.cardDesigner.addUpdate.save") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";

import axios from "axios";
import ItemInfo from "./ItemInfo";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import moment from "moment";
import Editor from "@tinymce/tinymce-vue";
import DesignerText from "@/components/DesignerText";
import DesignerImage from "@/components/DesignerImage";
import TextToolbar from "@/components/toolbar/TextToolbar";
import { quillEditor } from "vue-quill-editor";
export default {
  components: { ItemInfo, quillEditor, editor: Editor, DesignerImage, DesignerText, TextToolbar },
  name: "PrintSchemeAddUpdate",
  props: ["id"],
  data() {
    return {
      settingsDock: false,
      backgroundPercent: 0,
      addedObj: null,
      fonts: [],
      activeElement: null,
      loading: false,
      timeout: null,
      form: null,
      historyDate: new Date().getTime(),
      logoPercent: 0,
      axios,
      validationErrors: [],
      showInfo: false,
      moment,
      variables: [],
      editorConfig: {
        inline: true,
        height: "100mm",
        width: "100mm",
        menubar: false,
        table_resize_bars: true,
        plugins: ["advtable autolink lists link image", "searchreplace visualblocks code fullscreen", "print preview anchor insertdatetime media", "paste code table"],
        toolbar: "undo redo | table | fontselect |fontsizeselect bold italic | \
  alignleft aligncenter alignright | \
  ",
        fontsize_formats: "11px 12px 13px 14px 15px 16px 17px 18px 19px 20px 21px 22px 23px 24px 25px 26px 27px 28px 29px 30px 31px 32px 33px 34px 35px 36px",
        font_formats:
          "Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats"
      },
      textTemplate: {
        width: 100,
        textAlign: "center",
        fontWeight: "normal",
        fontSize: 14,
        fontFamily: "Roboto",
        textDecoration: "none",
        fontStyle: "normal",
        color: "#333",
        type: "text",
        position: "absolute",
        left: 0,
        top: 0,
        editable: false,
        content: this.$i18n.t("editText"),
        zIndex: 1
      },
      backgroundPercent: 0,
      imageTemplate: {
        width: 100,
        height: 100,
        left: 0,
        top: 0,
        zIndex: 1,
        content: "",
        type: "image",
        position: "absolute",
        radius: 0
      },
      groups: []
    };
  },
  async created() {
    this.loading = true;
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.$store.dispatch("getDynamicParams", { type: null, isPrintScheme: true });
      this.groups = this.dynamicParams.map(x => {
        return x.group;
      });
      this.groups = [...new Set(this.groups)];

      var res = await axios.post("/Certificate/ListFonts", { skip: 0, take: 1000, searchTerm: null });
      this.fonts = res.data.data.items;
      this.fonts.map(k => {
        var head = document.getElementsByTagName("head")[0];
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.type = "text/css";
        link.href = k.url;
        head.appendChild(link);
      });
      if (this.id != null && this.id != undefined) {
        var res = await this.$store.dispatch("getOnePrintScheme", this.id);
        if (!res.data.alert.hasError) {
          var canvas = JSON.parse(res.data.data.item.canvasData);
          this.form = {
            ...res.data.data.item,
            canvas: canvas
          };
        } else {
          this.$emit("closeDialog");
        }
      } else {
        this.form = {
          id: null,
          title: null,
          details: null,
          enableTextTransform: false,
          isActive: true,
          backgroundImageUrl: null,
          enableBackgroundImagePrint: false,
          width: 100,
          height: 50,
          marginTop: 0,
          marginBottom: 0,
          marginLeft: 0,
          marginRight: 0,
          printMode: 0,
          canvas: {
            elements: [],
            history: [],
            background: null
          }
        };
      }
      this.loading = false;
    }, 500);
  },

  computed: {
    dynamicParams() {
      return this.$store.getters.getDynamicParams;
    },
    getCanvasStyle() {
      return {
        width: this.form.width + "mm",
        height: this.form.height + "mm",
        // transform: "scale(" + this.form.canvas.zoom + ")",
        position: "relative",
        margin: "0"
      };
    },
    getActiveElement() {
      if (this.activeElement == null) return {};
      return this.form.canvas.elements.find(k => k.id == this.activeElement);
    }
  },
  methods: {
    backgroundProgress(event) {
      this.backgroundPercent = event.percent;
    },
    backgroundSuccess(response) {
      this.backgroundPercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.form.backgroundImageUrl = response.data.item.url;
      }
    },
    setActiveElement(id) {
      this.activeElement = id;
    },
    startEditing(id) {
      var index = this.form.canvas.elements.findIndex(k => k.id == id);
      this.$set(this.form.canvas.elements, index, {
        ...this.form.canvas.elements[index],
        editable: true
      });
    },
    stopEditing(id) {
      var index = this.form.canvas.elements.findIndex(k => k.id == id);
      this.$set(this.form.canvas.elements, index, {
        ...this.form.canvas.elements[index],
        editable: false
      });
    },
    positionUpdated({ position, id }) {
      var index = this.form.canvas.elements.findIndex(k => k.id == id);
      this.$set(this.form.canvas.elements, index, {
        ...this.form.canvas.elements[index],
        left: position.position.left,
        top: position.position.top
      });
    },
    sizeUpdated({ size, id }) {
      var index = this.form.canvas.elements.findIndex(k => k.id == id);
      this.$set(this.form.canvas.elements, index, {
        ...this.form.canvas.elements[index],
        width: size.size.width,
        height: size.size.height
      });
    },
    textChanged({ id, text }) {
      var index = this.form.canvas.elements.findIndex(k => k.id == id);

      this.form.canvas.elements[index].content = text;
    },
    addVar(variable) {
      if (variable == "123456") {
        // tinymce.activeEditor.insertContent("<img width='100' height='100' src='https://api.holacon.com/v1/Home/GetQRImage/GetQR/" + variable + "' />");
        this.form.canvas.elements.push({
          ...this.imageTemplate,
          id: uuidv4(),
          zIndex: this.form.canvas.elements.length + 1,
          content: "https://api.holacon.com/v2/Home/GetQRImage?qrText=" + variable
        });
      } else if (variable == "%111111%") {
        this.form.canvas.elements.push({
          ...this.imageTemplate,
          id: uuidv4(),
          zIndex: this.form.canvas.elements.length + 1,
          content: "https://holacon.s3.eu-central-1.amazonaws.com/public/default/default-user.png"
        });
      } else {
        // tinymce.activeEditor.insertContent(variable);
        this.form.canvas.elements.push({
          ...this.textTemplate,
          id: uuidv4(),
          zIndex: this.form.canvas.elements.length + 1,
          content: variable
        });
      }
    },
    deleteElement(id) {
      var index = this.form.canvas.elements.findIndex(k => k.id == id);
      this.setActiveElement(null);
      this.form.canvas.elements.splice(index, 1);
    },
    deleteItem() {
      this.$emit("deleteMe", this.form.id);
      this.$emit("closeDialog");
    },
    save() {
      this.loading = "saveCard";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        this.validationErrors = [];
        let stringHtml = document.getElementById("_canvas").outerHTML;
        var element = document.createElement("html");
        var cleanHtml = window.jQuery(window.jQuery.parseHTML(stringHtml));
        cleanHtml.find(".objectx").remove();
        if (!this.form.enableBackgroundImagePrint) {
          cleanHtml.find(".background-image-class").remove();
        }
        cleanHtml.find(".objecty").remove();
        cleanHtml.find(".ui-resizable-handle").remove();
        cleanHtml.find(".rotateButton").remove();

        var fontImport = '<link rel="preconnect" href="https://fonts.googleapis.com"> <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin> ';
        for (var i = 0; i < this.fonts.length; i++) {
          fontImport += '<link href="' + this.fonts[i].url + '" rel="stylesheet">';
        }
        fontImport += "<style>* {margin:0px !important;}</style>";
        var html = fontImport + cleanHtml[0].outerHTML;
        this.form.details = html;
        this.form.canvasData = JSON.stringify(this.form.canvas);

        var res = await axios.post("printscheme/addorupdate", { ...this.form });

        this.validationErrors = res.data.validationErrors;
        if (res.data.alert.hasError) {
          this.$message.error(res.data.alert.message);
        } else {
          this.$message.success(res.data.alert.message);
          var canvas = JSON.parse(res.data.data.item.canvasData);
          this.form = {
            ...res.data.data.item,
            canvas: canvas
          };
          await this.$store.dispatch("getPrintSchemes");
        }
        this.loading = false;
      }, 500);
    },
    logoProgress(event) {
      this.logoPercent = event.percent;
    },
    logoSuccess(response) {
      this.logoPercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.form.image = response.data.item.url;
      }
    }
  },
  watch: {
    addedObj: function() {
      if (this.addedObj != null) {
        this.addVar(this.addedObj);
        this.addedObj = null;
      }
    }
  }
  // created() {
  //   if (this.data != undefined && this.data != null) {
  //     var canvasDataC = {};
  //     if (this.data.canvasData != null) {
  //       canvasDataC = JSON.parse(this.data.canvasData);
  //     } else {
  //       var canvas = {
  //         elements: [],
  //         history: [],
  //       };
  //       canvasDataC = canvas;
  //     }
  //     this.form = {
  //       ...this.data,
  //       canvas: canvasDataC,
  //     };
  //   }
  // },
};
</script>
<style lang="less">
@import url(https://ajax.googleapis.com/ajax/libs/jqueryui/1.9.2/themes/base/jquery-ui.css);

#_designer_wrapper {
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
}

#_scene {
  display: flex;
  flex: 1;
  overflow: auto;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}
#_canvas {
  background-color: #fff;
  transition: 0.3s;
  box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.35);
  position: relative;
}
#_toolbar {
  background: white;
  padding: 5px 10px;
  margin: 0 auto;
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

#_canvas .active {
  border: 1px dotted !important;
}

.tox-sidebar-wrap,
.tox-edit-area {
  width: 100mm !important;
  height: 100mm !important;
}

.mce-content-body {
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
}
.ui-state-disabled,
.ui-widget-content .ui-state-disabled,
.ui-widget-header .ui-state-disabled {
  opacity: 1 !important;
  background-image: none;
}

.ui-resizable-handle.ui-icon {
  border: none !important;
}
#_designer_wrapper ._designer-element {
  border: 1px dotted #ddd;
  cursor: move;
}

#_designer_wrapper ._designer-element.active {
  border: 1px solid aqua;
  cursor: move;
}

#_zoomController {
  width: 80%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
}

.registerform-input-container {
  .tag-container {
    gap: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .badge-list {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    .badger {
      border-radius: 8px;
      background-color: #f3f3f3;
      height: 20px;
      padding: 10px;
    }
  }
  .title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
    label {
      font-weight: bold;
      color: black;
      margin-bottom: 0;
    }
    .title-container {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      align-items: center;
    }
  }
  display: flex;
  flex-direction: column;
  .el-input-number {
    width: 100%;
  }
}
.mage-maker {
  width: 100%;
  position: relative;
  border: 1px dashed #ccc;
  height: 250px;
  background-size: contain !important;
  background-position: center center !important;
  border-radius: 5px;
  background-repeat: no-repeat !important;
  .avatar-uploader {
    opacity: 0;
    transition: all 1s;
    &:hover {
      opacity: 1 !important;
    }
    & > .el-upload {
      background-color: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 250px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.group-btn-container {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  justify-content: flex-end;
  align-items: center;

  .el-button {
    padding: 4px;
    margin-left: 0;
  }
  i.el-icon-info {
    font-size: 24px;
  }
}
.model-base-small {
  min-width: 500px;
}
.switch-btn-container {
  display: flex;
  .el-button {
    flex-grow: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PrintSchemeAddUpdate.vue